import { ActionButton, Spinner, SpinnerSize } from '@fluentui/react';
import { useEffect, useRef } from 'react';
import { Utils } from '../../../common/views/Utils';
import InvoiceDetailView from '../../../invoices/views/shared/InvoiceDetailView';
import { ProductKeyModel } from '../../../products/models/ProductModel';
import ProductDetailWrapperView from '../../../products/views/users/ProductDetailWrapperView';
import { UserProductPictureService } from '../../../products/views/users/ProductView';
import { ShortOrderItemModel } from '../../models/OrderModel';
import { useOrderVM } from '../../viewmodels/OrderVM';
import OrderGridView from './OrderGridView';

export default function OrderView() {
    const pictureService = new UserProductPictureService();

    const hasLoaded = useRef(false);
    const vm = useOrderVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList(true);
    }, [vm]);

    const isMobile = window.innerWidth <= 500;

    const refreshButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Refresh" }}
                onClick={() => vm.getList(true)}
            >Refresh</ActionButton>
        </>;
    }

    const headerView = () => {
        return <div className="ph-15 container">
            <div className="font-title pr-10" style={{ marginBottom: 4 }}>Orders</div>
            {refreshButton()}
        </div>;
    }

    const onShowDetail = (item: ShortOrderItemModel) => {
        vm.setShowDetail(true);
        vm.setItem(item);
    }

    const onCloseDetail = () => {
        vm.setShowDetail(false);
        vm.setItem(null);
    }

    const onShowInvoice = (id: string) => {
        vm.setSelectedInvoice(id);
        vm.setShowInvoice(true);
    }

    const onCloseInvoice = () => {
        vm.setSelectedInvoice("");
        vm.setShowInvoice(false);
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <OrderGridView
                    items={vm.items}
                    key={vm.listHash}
                    onDetail={(item: ShortOrderItemModel) => {
                        vm.setShowDetail(true);
                        vm.setItem(item);
                    }}
                    onInvoiceDetail={onShowInvoice}
                />
            </div>
        </div>;
    }

    const createProductKey = (item: ShortOrderItemModel) => {
        const product: ProductKeyModel = {
            groupId: item.groupId,
            lineId: item.lineId,
            productId: item.productId
        };

        return product;
    }

    return <>
        {mainContent()}

        {vm.showDetail && vm.item !== null && <>
            <ProductDetailWrapperView
                product={createProductKey(vm.item)}
                pictureService={pictureService}
                onClose={onCloseDetail}
                isMobile={isMobile}
                addToCart={() => { }}
            />
        </>}

        {vm.showInvoice && !Utils.isNullOrEmpty(vm.selectedInvoice) && <>
            <InvoiceDetailView
                id={vm.selectedInvoice}
                onClose={onCloseInvoice}
            />
        </>}
    </>;
}